import { useMemo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import RefinementInput from 'Pages/TeamDashboard/CreateReview/components/DesignInspirationPanel/RefinementInput';

import styles from './styles.module.scss';

const PORTRAIT_FALLBACK_W = 402;
const PORTRAIT_FALLBACK_H = 874;
const LANDSCAPE_FALLBACK_W = 874;
const LANDSCAPE_FALLBACK_H = 402;

const CarouselRefinementPanel = ({
  onSubmit,
  isSubmitting,
  disabled,
  disabledReason,
  isLandscape,
  renderedDimensions,
  errorMessage,
}) => {
  const fallbackW = isLandscape ? LANDSCAPE_FALLBACK_W : PORTRAIT_FALLBACK_W;
  const fallbackH = isLandscape ? LANDSCAPE_FALLBACK_H : PORTRAIT_FALLBACK_H;
  const panelW = renderedDimensions?.width ?? fallbackW;
  const panelH = renderedDimensions?.height ?? fallbackH;
  const panelSizeStyle = useMemo(() => ({ width: panelW, height: panelH, flexShrink: 0 }), [panelW, panelH]);
  const panelFrameSizeStyle = useMemo(() => ({
    width: panelW + 32, height: panelH + 40, flexShrink: 0,
  }), [panelW, panelH]);

  return (
    <div className={cn(styles['prototype-side-panel'], isLandscape && styles['prototype-side-panel--landscape'])}>
      <div className={styles['prototype-panel-header']}>
        <p className={cn(styles['screen-label'], styles['screen-label--prototype'])}>
          &nbsp;
        </p>
      </div>

      <div
        className={styles['prototype-screen-wrapper']}
        style={panelFrameSizeStyle}
      >
        <div
          className={cn(
            styles['prototype-image-wrapper'],
            styles['refinement-slot-card']
          )}
          style={panelSizeStyle}
        >
          <div className={styles['refinement-slot-content']}>
            <p className={styles['refinement-slot-title']}>
              Something's missing?
              <br />
              Make a new variant
            </p>
            <div className={styles['refinement-slot-input']}>
              <RefinementInput
                onSubmit={onSubmit}
                isSubmitting={isSubmitting}
                disabled={disabled}
                stacked
              />
            </div>
            {errorMessage && (
              <p className={styles['refinement-slot-error']}>
                {errorMessage}
              </p>
            )}
            {disabled && disabledReason && (
              <p className={styles['refinement-slot-disabled-reason']}>
                {disabledReason}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

CarouselRefinementPanel.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string,
  isLandscape: PropTypes.bool,
  renderedDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  errorMessage: PropTypes.string,
};

CarouselRefinementPanel.defaultProps = {
  isSubmitting: false,
  disabled: false,
  disabledReason: null,
  isLandscape: false,
  renderedDimensions: null,
  errorMessage: null,
};

export default CarouselRefinementPanel;
